/* eslint-disable indent */
/* eslint-disable no-unused-vars */

const isObj = require('lodash.get');

export const getLanguage = (state) => isObj(state, 'language', []);
